module.exports = __webpack_public_path__ + "img/abnormal.9b168488.png";